export default "__VITE_ASSET__ZsRCnPNJ__"